import * as basicConstants from './basic';
import * as urlConstants from './url';
import theme from '../theme';
import { currentStage } from '../api/api';

export const FACEBOOK = 'FACEBOOK';
export const GOOGLE = 'GOOGLE';
export const LINE = 'LINE';
export const TABOOLA = 'TABOOLA';
export const SYSTEM = 'SYSTEM';

export const MEDIA_TYPE_INTERNAL = ['FACEBOOK', 'GOOGLE', 'LINE', 'TABOOLA'];
export const MEDIA_TYPE_EXTERNAL = ['FACEBOOK', 'GOOGLE'];
export const currentMediaType = currentStage.includes('ext') ? MEDIA_TYPE_EXTERNAL : MEDIA_TYPE_INTERNAL;

export const MEDIA_DATA = {
  FACEBOOK: {
    media: 'Facebook',
    capital: 'FACEBOOK',
    lowerCase: 'facebook',
    color: theme.palette.facebook.main,
    navClassName: 'nav-list-blue',
    sendListUrl: urlConstants.PAGE_FB_SEND_LIST,
    createDataUrl: urlConstants.PAGE_FB_CREATE_DATA,
    editDataUrl: urlConstants.PAGE_FB_EDIT_DATA,
    entryPath: basicConstants.FACEBOOK,
    reportTitle: 'd.report.facebook',
    api: {
      reportList: 'getReportList',
      deleteReport: 'deleteReport',
      testSend: 'testSend',
      sendAllEmails: 'sendAllEmails',
      testDownload: 'testDownload',
      downloadReport: 'downloadCustomReport',
      createReport: 'createReport',
      updateReport: 'updateReport',
      getCampaign: 'getCampaign',
    },
  },
  GOOGLE: {
    media: 'Google',
    capital: 'GOOGLE',
    lowerCase: 'google',
    color: theme.palette.google.dark,
    navClassName: 'nav-list-orange',
    sendListUrl: urlConstants.PAGE_GOOGLE_SEND_LIST,
    createDataUrl: urlConstants.PAGE_GOOGLE_CREATE_DATA,
    editDataUrl: urlConstants.PAGE_GOOGLE_EDIT_DATA,
    entryPath: basicConstants.GOOGLE,
    reportTitle: 'd.report.google',
    api: {
      reportList: 'getGoogleReportList',
      deleteReport: 'deleteGoogleReport',
      testSend: 'googleTestSend',
      sendAllEmails: 'googleSendAllEmails',
      testDownload: 'googleTestDownload',
      downloadReport: 'downloadGoogleReport',
      createReport: 'createGoogleReport',
      updateReport: 'updateGoogleReport',
      getCampaign: 'googleGetCampaign',
      customFields: 'googleCustomFields'
    },
  },
  LINE: {
    media: 'LINE',
    capital: 'LINE',
    lowerCase: 'line',
    color: theme.palette.line.main,
    navClassName: 'nav-list-green',
    sendListUrl: urlConstants.PAGE_LINE_SEND_LIST,
    createDataUrl: urlConstants.PAGE_LINE_CREATE_DATA,
    editDataUrl: urlConstants.PAGE_LINE_EDIT_DATA,
    entryPath: basicConstants.LINE,
    reportTitle: 'd.report.line',
    api: {
      reportList: 'getLineReportList',
      deleteReport: 'deleteLineReport',
      testSend: 'lineTestSend',
      sendAllEmails: 'lineSendAllEmails',
      testDownload: 'lineTestDownload',
      downloadReport: 'downloadLineReport',
      createReport: 'createLineReport',
      updateReport: 'updateLineReport',
      getCampaign: 'lineGetCampaign',
      customFields: 'lineCustomFields'
    },
  },
  TABOOLA: {
    media: 'Taboola',
    capital: 'TABOOLA',
    lowerCase: 'taboola',
    color: theme.palette.taboola.main,
    navClassName: 'nav-list-taboola',
    sendListUrl: urlConstants.PAGE_TABOOLA_SEND_LIST,
    createDataUrl: urlConstants.PAGE_TABOOLA_CREATE_DATA,
    editDataUrl: urlConstants.PAGE_LINE_EDIT_DATA,
    entryPath: basicConstants.TABOOLA,
    reportTitle: 'd.report.taboola',
    api: {
      reportList: 'getTaboolaReportList',
      deleteReport: 'deleteTaboolaReport',
      testSend: 'taboolaTestSend',
      sendAllEmails: 'taboolaSendAllEmails',
      testDownload: 'taboolaTestDownload',
      downloadReport: 'downloadTaboolaReport',
      createReport: 'createTaboolaReport',
      updateReport: 'updateTaboolaReport',
      getCampaign: 'taboolaGetCampaign',
      customFields: 'taboolaCustomFields'
    },
  }
}